// extracted by mini-css-extract-plugin
export default {"gettingStartedContainer":"iNGZkb","eyebrow":"PYUJOZ","arrowIcon":"fDdxGn","arrowWrapper":"EC0YmC","cardContainer":"vtZZHe"};